export const IMAGE_CORTIS_MEMBERS =
    'https://image.production.fruitsfamily.com/public/cortis/member_all.jpg';
export const IMAGE_CORTIS_MEMBER_MARTIN =
    'https://image.production.fruitsfamily.com/public/cortis/member_martin.jpg';
export const IMAGE_CORTIS_MEMBER_JAMES =
    'https://image.production.fruitsfamily.com/public/cortis/member_james.jpg';
export const IMAGE_CORTIS_MEMBER_JUHOON =
    'https://image.production.fruitsfamily.com/public/cortis/member_juhoon.jpg';
export const IMAGE_CORTIS_MEMBER_SEONGHYEON =
    'https://image.production.fruitsfamily.com/public/cortis/member_seonghyeon.jpg';
export const IMAGE_CORTIS_MEMBER_KEONHO =
    'https://image.production.fruitsfamily.com/public/cortis/member_keonho.jpg';